<app-theme-container>
  <app-general-header
    [name]="'Welcome back' + (username ? ', ' + username : '')"
    baseName="home"
    absoluteRoute
  ></app-general-header>

  <div class="home-page">
    @if (!loaded) {
      <div class="loading">
        <mat-spinner [diameter]="60"></mat-spinner>
      </div>
    } @else if (sections.length === 0) {
      <p class="empty-state">No shortcuts available yet — contact your administrator.</p>
    } @else {
      @if (recents.length) {
        <section class="recents">
          <h2>Recently visited</h2>
          <div class="tile-row">
            @for (recent of recents; track recent.route) {
              <app-shortcut-tile
                size="small"
                [displayName]="recent.displayName"
                [iconName]="recent.iconName"
                [route]="recent.route"
                [accentClass]="recent.accentClass"
                [contextLabel]="recent.contextLabel"
              ></app-shortcut-tile>
            }
          </div>
        </section>
      }

      @for (section of sections; track section.groupName) {
        <section class="shortcut-section">
          <h2>{{ section.groupName }}</h2>
          <div class="tile-grid">
            @for (shortcut of section.shortcuts; track shortcut.route) {
              <app-shortcut-tile
                [displayName]="shortcut.displayName"
                [iconName]="shortcut.iconName"
                [route]="shortcut.route"
                [accentClass]="shortcut.accentClass"
                [placeholder]="shortcut.placeholder ?? false"
              ></app-shortcut-tile>
            }
          </div>
        </section>
      }
    }
  </div>
</app-theme-container>
